import { AbstractControl, ValidationErrors, FormControl } from '@angular/forms';


export class CustomValidators {
    public static passwordStrength(control: AbstractControl): ValidationErrors {

        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
        const value = control.value;

        if (value && pattern.test(value) !== true) {
            return { 'weekPassword': true };
        }

        return null!;
    }

    public static isDate(control: FormControl): ValidationErrors {
        const value = control.value;
        if (value) {
            if (value.toString() === 'Invalid Date') {
                return { 'isNotDate': true };
            }
            try {
                const d = new Date(value.valueOf());
            } catch (e) {
                return { 'isNotDate': true };
            }
        }
        return null!;
    }
}

